import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { FeatureFlag, FeatureFlagsStore } from '@marineform/fe-data-access';
import {
  AppSurfaceStore,
  AuthStore,
  MANAGE_PATHS,
  SessionKindEnum,
} from '@marineform/manage-data-access';

/**
 * Gates market routes on EnableMarket. Operators go to manage home when it is off;
 * renters and anonymous users go to the login fallback.
 */
export const marketEnabledGuard: CanMatchFn = () => {
  const featureFlags = inject(FeatureFlagsStore);
  if (featureFlags.isEnabled(FeatureFlag.EnableMarket)) {
    return true;
  }

  const authStore = inject(AuthStore);
  const router = inject(Router);
  const appSurfaceStore = inject(AppSurfaceStore);

  if (authStore.sessionKind() === SessionKindEnum.OPERATOR) {
    return router.createUrlTree([appSurfaceStore.homePath()]);
  }

  return router.createUrlTree([`/${MANAGE_PATHS.LOGIN}`]);
};
